import axios from "axios/index";

export const getList = params => axios.post('/business/deviceOperationLog/getList', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});